/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('LugarAdminController', LugarAdminController);

    /* @ngInject */
    function LugarAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                  ModalService, Lugar, AlertService, letras) {
        var vm = this;

        // Letras
        vm.letras = letras;
        vm.values = {};


        vm.esCanonico = false;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Lugar;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra,
            revisado: undefined
        };


        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (lugar) {

            //si tiene alguna variante asociada, no se puede eliminar
            if ((lugar.variantes != null) && (lugar.variantes.length > 0)) {
                AlertService.warning("admin.lugar.error.notdeleteablePorVariantes");
                return;
            }
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        /* @ngInject */
                        item: function (Lugar) {
                            return Lugar.get({id: lugar.id}).$promise;
                        },
                        params: function () {

                            return {
                                title: 'admin.lugar.delete.name',
                                body: 'admin.lugar.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                    var originalTable = vm.tableParams;
                    for (i = 0; i < originalTable.data.length; i++) {
                        var originalData = originalTable.data[i];

                        if (originalData.id == lugar.id) {
                            originalTable.data.splice(i, 1);
                        } else {
                            if (originalData.variantes.length > 0) {
                                for (var j = 0; j < originalData.variantes.length; j++) {
                                    if (originalData.variantes[j].id == lugar.id) {
                                        originalData.variantes.splice(j, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            );
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;
            //no se permite añadir varios elementos simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;
        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba
                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false
            }
        };

        // Abrir ventana modal para establecer coordenadas
        vm.openLocationModal = function (lugar) {
            ModalService.open({
                templateUrl: 'app/admin/tesauro/lugar/ubicacion/ubicacion.form.modal.html',
                controller: 'UbicacionFormController',
                controllerAs: 'ctrl',
                backdrop: 'static',
                windowClass: 'modal-map',
                size: 'lg',
                resolve: {
                    /* @ngInject */
                    item: function (Lugar) {
                        return Lugar.get({id: lugar.id}).$promise;
                    }
                }
            }).result.then(function (data) {
                // TODO: Hacer algo con la información que se devuelve?
                // var itemOriginal = vm.originalData.filter(function (r) {
                //     return r.id === row.id;
                // });
                // angular.extend(itemOriginal, data);
                // angular.extend(row, data);
            });
        };

        vm.setRevisado = function (data) {
            Lugar.setRevisado({id: data.id, revisado: data.revisado}).$promise.then(function () {
                vm.tableParams.reload();
            });
        };
        /**
         * lugarCanonico: es el objeto Lugar, que es un atributo de la clase Lugar
         * A mayores, tambien tiene un id_canonico y un nombre_canonico, propios del LugarDTO
         * es_canonico es necesario para implementar el checkbox
         * @param row
         * @param rowForm
         */
        vm.save = function (row, rowForm) {
            var originalRow = angular.copy(vm.originalData);
            var antesNumeroVariantes = originalRow.numVariantes;
            var antesIdCanonico = originalRow.id_canonico;


            var ahoraEsCanonico = (row.es_canonico);
            var ahoraTieneNombrecanonico = (row.lugarcanonico != null);
            var ahoraIdCanonico = row.id_canonico;


            //Si no es canonico y no le añades un nombre de canonico
            //A pesar del required, puede ocurrir
            if (!ahoraEsCanonico && !ahoraTieneNombrecanonico) {
                AlertService.warning("admin.lugar.error.lugarIncompleto");
                return;
            }

            //Si es canonico, ponemos la variable asociada lugarCanonico a null(problemas de compatibilidad con backend)
            if (ahoraEsCanonico) {
                row.lugarcanonico = null;
            }

            //Modificar lugar: Si antes era canonico, tiene variantes, y ahora se quiere convertir a variante -> no se puede ACTUALIZAR
            // (ej: si antes era canonico, y ahora lo sigue siendo, sí se podría actualizar
            if (antesIdCanonico == null && !ahoraEsCanonico && antesNumeroVariantes > 0) {
                AlertService.warning("admin.lugar.error.notdeleteablePorVariantes");
                return;
            }

            new Lugar(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);

                vm.tableParams.reload();
            });
        };
        vm.lugarService = Lugar;
    }
})(angular);
